/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserInfo } from './userInfo';


export interface TaskAnnotationStatus { 
    userEmail: string;
    userId?: string;
    userInfo?: UserInfo;
    opened: boolean;
    annotated: boolean;
    submitted: boolean;
}

